var map = {
	"./de/translation.json": 7778,
	"./en/translation.json": 4362,
	"./es/translation.json": 6089,
	"./fr/translation.json": 9633,
	"./hi/translation.json": 8282,
	"./ja/translation.json": 3784,
	"./ko/translation.json": 9139,
	"./ru/translation.json": 6252,
	"./zh/translation.json": 7307
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9832;